module.exports = __webpack_public_path__ + "img/slide9.14b57abf.png";